import { useEvent } from 'effector-react';
import { openModalEvent } from '@nx-frontend/shared/ui/modal';
import { AddonPopupPayload, PopupType } from '@nx-frontend/shared/types';

export const useOpenAddonPopup = () => {
  const [openModal] = useEvent([openModalEvent]);
  return ({ payload }: { payload: AddonPopupPayload }) => {
    openModal({
      content: PopupType.ADDON,
      showCloseButton: false,
      modalContainerStyles: '!rounded-2xl',
      usePadding: false,
      multipopup: false,
      payload,
    });
  };
};
